// extracted by mini-css-extract-plugin
module.exports = {"backButton":"ScreenRecorder_backButton__3H9pI"};